/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { DefaultContainerLayout } from '@/data/types/ContainerLayout';

const Layout: DefaultContainerLayout = {
	name: 'ProductPageLayout',
	containerName: 'intertoys-product-page-container_rv',
	isStoreDefault: true,
	slots: [
		{
			id: '1',
			widgets: [
				{
					widgetName: 'breadcrumb-trail-widget',
					sequence: 0,
					name: 'BreadcrumbTrail',
				},
			],
		},
		{
			id: '2',
			widgets: [
				{
					widgetName: 'pdp-full-image-widget-rv',
					sequence: 0,
					name: 'PDP Full Image Image Widget',
				},
			],
		},
		{
			id: '3',
			widgets: [
				{
					widgetName: 'pdp-product-name-and-details-widget-rv',
					sequence: 0,
					name: 'PDP Product Name And Details Widget',
				},
				{
					widgetName: 'usps-delivery-terms-widget',
					sequence: 1,
					name: 'USPsDeliveryTermWidget',
				}
			],
		},
		{
			id:'4',
			widgets:[
				{
					widgetName: 'pdp-product-description-widget-rv',
					sequence:0,
					name:'PDP Product Description Widget'
				}
			]
		},
		{
			id:'9',
			widgets:[
				{
					widgetName: 'pdp-bazaar-voice-widget-rv',
					sequence:0,
					name:'PDP Bazaar Voice Widget'
				}
			]
		}
	],
};

export default Layout;
